import angular from 'angular';
import MODULE_NAME from '../../app'
import appSettings from './appSettingsValue'

angular.module(MODULE_NAME)
.value('appSettings', appSettings)


// WEBPACK FOOTER //
// ./src/app/scripts/values/index.js